import { createMutationHook } from '../../createMutationHook'
import { ApplicationForm } from '../../types'

export default createMutationHook<{}, ApplicationForm>({
  httpMethod: 'POST',
  getEndpoint: () => 'app/application-forms/application'
})
